import { cloneDeep } from "lodash";

export const getFormattedResponse = (response) => {
  const { formData } = response;

  if (formData.length) {
    return formData.map((data) => {
      if (
        data?.type === "input" &&
        data?.options?.length >= 5 &&
        data?.options[0]?.name?.startsWith("submitter_firstName") &&
        data?.options[2]?.type === "phoneNumber"
      ) {
        data["type"] = "contactInfo";
      } else if (
        data?.type === "input" &&
        data?.options[0]?.name?.startsWith("submitter_firstName")
      ) {
        data["type"] = "nameAndSurname";
      } else if (
        data?.type === "input" &&
        data?.options[0]?.name?.startsWith("submitter_address")
      ) {
        data["type"] = "address";
      } else if (
        data?.type === "input" &&
        data?.options[0]?.name?.startsWith("submitter_domain")
      ) {
        data["type"] = "domain";
      } else if (
        data?.type === "input" &&
        data?.options[0]?.name?.startsWith("submitter_email")
      ) {
        data["type"] = "email";
      }

      if (data?.type === "payment") {
        const last4Digit = data?.paymentId.substr(
          data?.paymentId.length - 5,
          data?.paymentId.length - 1
        );

        data["title"] = `Payment-${last4Digit}`;
        data["name"] = `payment_${data?.paymentId}`;
      }

      return data;
    });
  } else {
    return [];
  }
};

const getUniqueAndNonRepetiveElements = (dataProvider) => {
  if (dataProvider.length === 0) {
    return [];
  }

  const uninqueElements = Array.from(
    new Set(dataProvider.map((data) => data.name))
  );

  return uninqueElements.filter(
    (element) => dataProvider.filter((data) => data.name === element).length > 1
  );
};

const getUniqueAndNonRepetiveOptionElements = (dataProvider) => {
  if (dataProvider.length === 0) {
    return [];
  }

  const options = [];

  dataProvider.forEach((data) => {
    data.options?.length &&
      data.options.forEach((option) => {
        options.push(option);
      });
  });

  const uninqueElements = Array.from(
    new Set(options.map((option) => option.name))
  );

  return uninqueElements.filter(
    (element) => options.filter((option) => option.name === element).length > 1
  );
};

export const getFormattedUniqueData = (dataProvider) => {
  const uniqueAndNonRepetiveElements =
    getUniqueAndNonRepetiveElements(dataProvider);

  const uniqueAndNonRepetiveOptionElements =
    getUniqueAndNonRepetiveOptionElements(dataProvider);

  let dataNameCount = 0;
  let optionNameRepeatCount = 0;

  const clonedDataProvider = cloneDeep(dataProvider);

  clonedDataProvider.forEach((data) => {

    if (data.type === 'select' && Array.isArray(data.options)) {
      const seenIds = [];
      data.options.forEach((opt) => {
        if (seenIds.includes(opt.id)) {
          opt.id = "";
          opt.name = "";
        } else {
          seenIds.push(opt.id);
        }
      });
    }

    let optionNameCount = 0;
    if (Array.isArray(data.options) && data.options.length) {
      const numbers = data.options
        .map(opt => {
          const match = opt?.name?.match(/_(\d+)(?:_|$)/);
          return match ? parseInt(match[1], 10) : 0;
        })
        .filter(n => !isNaN(n));

      optionNameCount = numbers.length ? Math.max(...numbers) : 0;
    }

    if (uniqueAndNonRepetiveElements.includes(data.name)) {
      dataNameCount++;
      data.name = `${data.name
        .trim()
        .replace(" ", "_")
        .toLowerCase()}_${dataNameCount}`;
    }

    data.options?.length &&
      data.options?.forEach((option) => {
        if (option?.name?.length === 0 || option?.name?.length === undefined) {
          optionNameCount++;
          option.name = `${data.name}_${option?.type === 'otherField' ? "other" : "option"}_${optionNameCount}`;
          option.id = option.id || `${data.name}_${option?.type === 'otherField' ? "other" : "option"}_${optionNameCount}`;
        }
        else if (uniqueAndNonRepetiveOptionElements.includes(option.name)) {
          optionNameRepeatCount++;
          option.name = `${option.name}_${optionNameRepeatCount}`;
          option.id = option.id || `${option.name}_${optionNameRepeatCount}`;
        }
      });


    if (data?.type === "payment") {
      delete data.title;
      delete data.name;
    }
  });

  return clonedDataProvider;
};
